export default __webpack_public_path__ + "static/media/trash-bin.098a544e.svg";